 

export default class AcademicCourse {

    Id: string | undefined;
    InstitutionName: string | undefined;
    CourseName: string | undefined;
    YearCompletion: number | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    
    static NewInstance() {
        return new AcademicCourse();
    }
}